import _ from 'lodash';
import React, { FC } from 'react';
import ReactSlider from 'react-slider';
import styled from 'styled-components';

const SliderContainer = styled.div`
    background-color: white;
    border: 1px #ddd solid;
    border-radius: 4px;
    padding: 5px 20px;
    height: 40px;
    display: flex;
    align-items: center;
    min-width: 200px;
`;

const StyledSlider = styled(ReactSlider)`
    width: 100%;
    height: 5px;
`;

const StyledThumb = styled.div`
    height: 25px;
    line-height: 25px;
    width: 25px;
    text-align: center;
    font-size: 10px;
    background-color: ${(props) => props.theme.app.primary_dark};
    color: #fff;
    border-radius: 50%;
    top: -10px;
    outline: none;
    cursor: grab;
`;

const Thumb = (props: object, state: { index: number; value: number | readonly number[]; valueNow: number | readonly number[] }) => (
    <StyledThumb {...props}>{state.valueNow}</StyledThumb>
);

const StyledTrack = styled.div<{ index: number }>`
    top: 0;
    bottom: 0;
    background: ${(props) => (props.index === 2 ? '#f00' : props.index === 1 ? '#CCC' : '#ddd')};
    border-radius: 999px;
`;

const StyledCaption = styled.span`
    display: inline-block;
    font-size: 12px;
    line-height: 16px;
    color: rgb(68, 90, 100);
    margin-top: 4px;
`;

const Track = (props: object, state: { index: number; value: number | readonly number[] }) => <StyledTrack {...props} index={state.index} />;

type SliderProps = React.ComponentProps<typeof ReactSlider> & {
    caption?: string;
    className?: string;
};

const Slider: FC<SliderProps> = (props) => {
    return (
        <>
            <SliderContainer className={props.className}>
                <StyledSlider {..._.omit(props, ['css', 'className', 'caption'])} renderTrack={Track} renderThumb={Thumb} />
            </SliderContainer>
            {props.caption && <StyledCaption>{props.caption}</StyledCaption>}
        </>
    );
};

export default Slider;
